import Drawer from "@mui/material/Drawer";
import Link from "next/link";
import { Text } from "@utils/helper";
import LangChange from "@components/Home/LangChange";
import { useSelector } from "noval";

const MobileDrawer = ({ t, lang, onClose, openNav, navLinks }) => {
  const isLogged = useSelector("user");

  return (
    <Drawer
      open={openNav}
      onClose={onClose}
      PaperProps={{ style: { backgroundColor: "transparent" } }}
      sx={{
        "& .MuiDrawer-paper": {
          right: lang === "ar" ? "0" : "auto",
          left: lang === "en" ? "0" : "auto",
        },
      }}
    >
      <div
        className="w-full h-screen text-[#fff] flex flex-col items-center gap-8 p-8 min-w-[280px]"
        style={{ background: "#fff", color: "#333" }}
      >
        {navLinks.map((item, index) => (
          <Link
            key={index}
            href={item.link}
            onClick={onClose}
            className="w-full"
          >
            <Text
              fontType="Expo_sim"
              color="#333"
              weight="700"
              className="leading-[21px]"
            >
              {item.title}
            </Text>
          </Link>
        ))}
        <Link
          href={isLogged ? "/home" : "/login"}
          onClick={onClose}
          className="flex justify-center items-center rounded-[10px] h-[43px] px-6 w-full"
          style={{ background: "#0366FF" }}
        >
          <Text
            fontType="Expo_sim"
            color={"#fff"}
            weight="700"
            className="leading-[21px]"
          >
            {isLogged ? t("slide.home") : t("common-locale:navbar.login")}
          </Text>
        </Link>
        <LangChange iconWhite={false} />
      </div>
    </Drawer>
  );
};

export default MobileDrawer;
